module.exports = __webpack_public_path__ + "img/t.7265f54c.jpg";